import { gasNatural } from '../data/combustibles';

// Función para calcular la energía total según el tipo de combustible
export const calcularEnergiaCombustible = (combustible, consumo) => {
  switch (combustible.id) {
    case 'gasolina':
    case 'diesel':
      // Galones -> Litros -> Kilogramos -> MJ
      const litros = consumo * combustible.litrosPorGalon;
      const kilogramos = litros * combustible.densidad;
      return kilogramos * combustible.poderCalorifico;
      
    case 'glp':
      // Kilogramos -> MJ (ya viene en kg)
      return consumo * combustible.poderCalorifico;
      
    case 'carbon':
      // Toneladas -> Kilogramos -> MJ
      return consumo * combustible.kgPorTonelada * combustible.poderCalorifico;
      
    default:
      return 0;
  }
};

// Función principal para realizar todos los cálculos
export const realizarCalculoCompleto = (combustible, consumo) => {
  if (!combustible || !consumo) {
    return null;
  }

  const consumoNum = parseFloat(consumo);
  
  if (isNaN(consumoNum) || consumoNum <= 0) {
    return null;
  }

  // 1. Calcular energía total con el combustible actual (MJ)
  const energiaTotalActual = calcularEnergiaCombustible(combustible, consumoNum);
  
  // 2. Calcular emisiones de CO2 con el combustible actual
  const emisionesCO2Actuales = consumoNum * combustible.factorEmision;
  
  // 3. Calcular el volumen equivalente de gas natural para la misma energía
  const volumenGasNaturalEquivalente = energiaTotalActual / gasNatural.poderCalorifico;
  
  // 4. Calcular emisiones de CO2 con gas natural
  const emisionesCO2GasNatural = volumenGasNaturalEquivalente * gasNatural.factorEmision;
  
  // 5. Calcular la reducción de emisiones
  const reduccionEmisiones = emisionesCO2Actuales - emisionesCO2GasNatural;
  const reduccionEmisionesPorcentaje = (reduccionEmisiones / emisionesCO2Actuales) * 100;
  
  // 6. Estimar costos
  const preciosCombustible = {
    gasolina: 9.5,
    diesel: 8.8,
    glp: 2.2,
    carbon: 220,
  };
  
  const precioGasNatural = 0.85;
  
  const costoActual = consumoNum * (preciosCombustible[combustible.id] || 0);
  const costoGasNatural = volumenGasNaturalEquivalente * precioGasNatural;
  const ahorroEstimado = costoActual - costoGasNatural;
  
  // 7. Calcular equivalencias ambientales
  const emisionPromedioAutoMensual = 383.33; // kg CO2/mes
  const absorcionCO2ArbolEucaliptoMensual = 1.81; // kg CO2/mes
  
  const carrosEquivalentes = reduccionEmisiones / emisionPromedioAutoMensual;
  const arbolesEquivalentes = Math.round(reduccionEmisiones / absorcionCO2ArbolEucaliptoMensual);
  
  // 8. Calcular retorno de inversión
  const costoInstalacion = 2500;
  const retornoInversion = ahorroEstimado > 0 ? Math.ceil(costoInstalacion / ahorroEstimado) : 0;
  
  return {
    ahorroEstimado: ahorroEstimado.toFixed(2),
    emisionesCO2Actuales: emisionesCO2Actuales.toFixed(2),
    emisionesCO2GasNatural: emisionesCO2GasNatural.toFixed(2),
    reduccionEmisiones: reduccionEmisiones.toFixed(2),
    reduccionEmisionesPorcentaje: reduccionEmisionesPorcentaje.toFixed(1),
    retornoInversion: retornoInversion,
    combustibleNombre: combustible.nombre,
    unidad: combustible.unidad,
    consumo: consumoNum,
    volumenGasNatural: volumenGasNaturalEquivalente.toFixed(2),
    energiaTotalActual: energiaTotalActual.toFixed(2),
    costoActual: costoActual.toFixed(2),
    costoGasNatural: costoGasNatural.toFixed(2),
    carrosEquivalentes: carrosEquivalentes.toFixed(1),
    arbolesEquivalentes: arbolesEquivalentes
  };
};